import React from 'react';

import GenericFormComponent from './GenericFormComponent';
import HarmonyRegFormComponent from './HarmonyRegFormComponent';
import MelintaRegFormComponent from './MelintaRegFormComponent';
import VeloxisRegFormComponent from './VeloxisRegFormComponent';
import VericelRegFormComponent from './VericelRegFormComponent';
import VandaRegFormComponent from './VandaRegFormComponent';
import SobiRegFormComponent from './SobiRegFormComponent';
import FmiRegFormComponent from './FmiRegFormComponent';
import SklsiRegFormComponent from './SklsiRegFormComponent';
import AxsomeRegFormComponent from './AxsomeRegFormComponent';
import UrogenRegFormComponent from './UrogenRegFormComponent';
import EisaiRegFormComponent from './EisaiRegFormComponent';

const regFormMapping = {
  harmony: HarmonyRegFormComponent,
  melinta: MelintaRegFormComponent,
  veloxis: VeloxisRegFormComponent,
  vericel: VericelRegFormComponent,
  vericelburncare: VericelRegFormComponent,
  vericelmaci: VericelRegFormComponent,
  vanda: VandaRegFormComponent,
  sobi: SobiRegFormComponent,
  foundationmedicineinc: FmiRegFormComponent,
  sklsi: SklsiRegFormComponent,
  axsomeprograms: AxsomeRegFormComponent,
  urogen: UrogenRegFormComponent,
  esi: EisaiRegFormComponent
};

const renderRegComponent = (tenant) => {
  console.log('renderRegComponent tenant', tenant);
  const RegFormComponent = regFormMapping[tenant] ? regFormMapping[tenant] : GenericFormComponent;
  return <RegFormComponent />;
};

export default renderRegComponent;
